import { render, staticRenderFns } from "./ManageUser.vue?vue&type=template&id=4b6b2fb7&scoped=true"
import script from "./ManageUser.vue?vue&type=script&lang=js"
export * from "./ManageUser.vue?vue&type=script&lang=js"
import style0 from "./ManageUser.vue?vue&type=style&index=0&id=4b6b2fb7&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b6b2fb7",
  null
  
)

export default component.exports